import React from "react";
import BaseAlert from "./BaseAlert";

export default function Modals() {
  return <BaseAlert />;
}
